import { html } from "../../render";
import { cn, spreadAttrs } from "../../utils";
import { LpIcon } from "../icon";
export const LP_EMPTY_SIZES = ["sm", "base", "lg"];
const managedAttrs = ["data-lp-component", "class", "data-size"];
export function LpEmpty({ title, description, icon, iconWeight = "regular", contents, size = "base", className, attributes, }) {
    return html `
        <div
            data-lp-component="Empty"
            class="${cn("lp-empty", className, attributes?.class)}"
            data-size="${size}"
            ${spreadAttrs(attributes, { omit: managedAttrs })}
        >
            ${icon
        ? html `<span class="lp-empty_icon" aria-hidden="true">${LpIcon({ name: icon, weight: iconWeight })}</span>`
        : ""}
            <div class="lp-empty_title">${title}</div>
            ${description
        ? html `<div class="lp-empty_description">${description}</div>`
        : ""}
            ${contents ? html `<div class="lp-empty_contents">${contents}</div>` : ""}
        </div>
    `;
}
